import React from 'react'

function Colors({colors}) {
    return (
        <div className="color-list">
            
            {colors.map((oneColor, j) => {
                    return <div key={j} className="color-container">
                        <span className="color-block" style={{backgroundColor: oneColor.colorcode}}></span>
                        <div className="color-info">
                            <h4 className="color-name">{oneColor.colorname}</h4>
                            <p className="color-code">{oneColor.colorcode}</p>
                        </div>
                        
                    </div>
                    })}
        </div>
    )
}

export default Colors
